import config from "../../../config";
import sendRequest from "../../../helpers/requestHelper";
import eventBus from "../../../event-bus/eventBus";

const deleteProjectTask = {
    namespaced: true,
    state: {
        isShowModalDeleteProjectTask: false
    },
    mutations: {
        UPDATE_VISIBLE_MODAL_DELETE_PROJECT_TASK(state, value) {
            state.isShowModalDeleteProjectTask = value;
        },
        DELETE_PROJECT_TASK_SUCCESS(state, response) {
            let dataReceive = {
                title: response.data.message,
                message: response.data.data.textInfo
            };
            eventBus.$emit("deleteProjectTaskSuccess", dataReceive);
        },
        DELETE_PROJECT_TASK_FAILURE(state, error) {
            console.log(error);
        }
    },
    actions: {
        deleteProjectTask: function({ dispatch }, payload) {
            let promise = sendRequest("delete", config.baseURLApi + "/project-tasks/" + payload.creds.id, {});
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDeleteProjectTask", result[1]);
                } else {
                    dispatch("failureDeleteProjectTask", result[1]);
                }
            })
        },
        successDeleteProjectTask: function({ commit }, response) {
            commit("DELETE_PROJECT_TASK_SUCCESS", response);
        },
        failureDeleteProjectTask: function({ commit }, error) {
            commit("DELETE_PROJECT_TASK_FAILURE", error);
        },
        updateVisibleModalDeleteProjectTask: function({ commit }, value) {
            commit("UPDATE_VISIBLE_MODAL_DELETE_PROJECT_TASK", value);
        },
    }
}

export default deleteProjectTask;